import type { Citation } from "../types";
import data from "./sources.json";

/**
 * Cited sources and the registration facts the cheat-sheet build also stamps.
 * Kept as JSON so the Python build scripts can read it; decisions live in tables.ts.
 */
export const sources = data;

export type CitationId = keyof typeof data.citations;

export function cite(id: CitationId): Citation & { id: CitationId } {
  return { id, ...data.citations[id] };
}
